import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { GeoJSONgeneric } from "../../pages/Verification/types";

interface IInitialState {
  selectedCountry: string | null;
  latitude: number | string | undefined;
  longitude: number | string | undefined;
  originUploadedFile: GeoJSONgeneric | null;
}
const initialState: IInitialState = {
  selectedCountry: null,
  latitude: "",
  longitude: "",
  originUploadedFile: null,
};
export const verificationSlice = createSlice({
  name: "verificationSlice",
  initialState,
  reducers: {
    setSelectedCountry: (state, action) => {
      state.selectedCountry = action.payload;
    },
    setLatitude: (state, action) => {
      state.latitude = action.payload;
    },

    setLongitude: (state, action) => {
      state.longitude = action.payload;
    },
    setOriginUploadedFile: (state, action) => {
      state.originUploadedFile = action.payload;
    },
  },
});

export const {
  setSelectedCountry,
  setLongitude,
  setLatitude,
  setOriginUploadedFile,
} = verificationSlice.actions;

export const selectedCountrySelector = (state: RootState) =>
  state.verificationSlice.selectedCountry;
export const latitudeSelector = (state: RootState) =>
  state.verificationSlice.latitude;
export const longitudeSelector = (state: RootState) =>
  state.verificationSlice.longitude;
export const originUploadedFileSelector = (state: RootState) =>
  state.verificationSlice.originUploadedFile;

export default verificationSlice.reducer;
